import { BotDetectionService } from '@naturalcycles/js-lib'

export const APP_STORE_URL =
  'https://itunes.apple.com/us/app/natural-cycles-fertility-app/id765535549?mt=8'

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.naturalcycles.cordova&hl='

export const SHOPIFY_US_DOMAIN = 'webshop.naturalcycles.com'

export const SHOPIFY_ADMIN_DOMAIN = 'naturalcycles-us.myshopify.com'

export const botDetectionService = new BotDetectionService({
  memoizeResults: true,
  treatCDPAsBotReason: true,
})

export function isE2eTest(): boolean {
  return typeof window !== 'undefined' && !!(window as any).IS_E2E_TEST
}

export function isPtCycleMattersAvailable(): boolean {
  /**
   * TO BE DONE AT SAME TIME AS RELEASE OF PT CYCLEMATTERS:
   * - publish all Portuguese cyclematter content in Dato
   * - add PT CycleMatters url to the sitemap
   */
  const GATSBY_ENV = process.env['GATSBY_ENV']
  const isAvailable = GATSBY_ENV !== 'production'
  console.log('isPtCycleMattersAvailable', isAvailable)
  return isAvailable
}
